import * as yup from 'yup'

export class Needs7501DocumentMichiganEmailExporterDto {
  specialNotes?: string = undefined
  sentToEmailExporterDateTime?: string = undefined
}

export const needs7501DocumentMichiganEmailExporterValidationSchema = yup.object({
  specialNotes: yup.string().max(2_000, 'Special Notes cannot be more than 2,000 characters.').nullable()
})
